export default {
  "content": "<path d=\"M15.854 12.887l-6.9-11.844a1.11 1.11 0 00-1.908 0l-6.9 11.844A1.079 1.079 0 001.1 14.5h13.8a1.08 1.08 0 00.954-1.613zM8 12.5a1 1 0 110-2 1 1 0 010 2zm1-4a1 1 0 11-2 0v-3a1 1 0 012 0v3z\" fill=\"#C25700\"/>",
  "attrs": {
    "width": "16",
    "height": "15",
    "viewBox": "0 0 16 15",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};